declare namespace $ {

	type $mol_button_minor__hint_shm_hitalama_process_monitor_detail_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_process_monitor_detail_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor_detail['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_process_monitor_detail_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_process_monitor_detail_process__key_shm_hitalama_process_monitor_detail_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_monitor_detail['key'] >
		,
		ReturnType< $shm_hitalama_process_monitor_detail_process['key'] >
	>
	export class $shm_hitalama_process_monitor_detail extends $mol_page {
		method_title( ): string
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		Process( ): $shm_hitalama_process_monitor_detail_process
		key( ): string
		title( ): ReturnType< $shm_hitalama_process_monitor_detail['method_title'] >
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
	export class $shm_hitalama_process_monitor_detail_process extends $shm_hitalama_process_view {
		key( ): string
	}
	
}

//# sourceMappingURL=detail.view.tree.d.ts.map